import api from './index';
import { ApiResponse, Product, CartItem } from '../types';

export const shopifyApi = {
  /**
   * Get VIP products from Shopify
   */
  async getProducts(): Promise<Product[]> {
    const response = await api.get<ApiResponse<{ products: Product[] }>>('/shopify/products');

    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Failed to fetch products');
    }

    return response.data.data.products;
  },

  /**
   * Create cart and get checkout URL
   */
  async createCart(items: CartItem[]): Promise<string> {
    const response = await api.post<ApiResponse<{ checkoutUrl: string }>>('/shopify/cart', {
      items,
    });

    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Failed to create cart');
    }

    return response.data.data.checkoutUrl;
  },
};

export default shopifyApi;
